var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"hero-ic ml-2",attrs:{"type":"button"},on:{"click":_vm.goToSettings}},[_c('v-icon',{attrs:{"size":"10","color":"currentColor"}},[_vm._v("mdi-cog")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }